/**
 * LOT-UI-02 — Dashboard technicien (atelier-first, REP-V2).
 */
import React from 'react';
import { Link } from 'react-router-dom';
import { Wrench, PlusCircle, Package, Smartphone } from 'lucide-react';
import { DASH_CTA, DASH_PANEL, DashboardSectionTitle } from '../../features/dashboard/dashboardV2Ui';

const TechnicienDashboard = ({ stats, username }) => (
  <div className="space-y-5 max-w-lg mx-auto w-full" data-testid="dashboard-technicien">
    <DashboardSectionTitle
      title={`Atelier — ${username || ''}`}
      subtitle={`${stats?.repairs_in_progress || 0} réparation(s) en cours`}
    />
    <Link to="/reparations" className={DASH_CTA} data-testid="technicien-repar-cta">
      <Wrench className="w-12 h-12 text-red-400 mb-3" />
      <span className="text-xl font-bold text-white">File d&apos;attente atelier</span>
    </Link>
    <div className="grid grid-cols-2 gap-3">
      <Link to="/reparations/nouveau" className={`${DASH_PANEL} flex flex-col items-center p-6 hover:border-white/20 transition-colors`}>
        <PlusCircle className="w-8 h-8 text-red-400 mb-2" />
        <span className="text-sm font-bold text-white text-center">Nouvelle réparation</span>
      </Link>
      <Link to="/commandes" className={`${DASH_PANEL} flex flex-col items-center p-6 hover:border-white/20 transition-colors`}>
        <Package className="w-8 h-8 text-gray-400 mb-2" />
        <span className="text-sm font-bold text-white text-center">Commandes pièces</span>
      </Link>
    </div>
    {stats?.recent_repairs?.length > 0 && (
      <div className={`${DASH_PANEL} p-4`}>
        <h3 className="font-bold text-sm mb-3 flex items-center gap-2 text-white">
          <Smartphone className="w-4 h-4 text-red-400" /> Dernières réparations
        </h3>
        <div className="space-y-1">
          {stats.recent_repairs.slice(0, 5).map((r, i) => (
            <Link key={i} to={`/reparations/${r.ref}`} className="block p-2.5 rounded-lg hover:bg-white/5 text-sm border border-transparent hover:border-white/5">
              <span className="font-mono font-medium text-red-300">{r.ref}</span>
              <span className="text-gray-500 ml-2">{r.marque} {r.model}</span>
            </Link>
          ))}
        </div>
      </div>
    )}
  </div>
);

export default TechnicienDashboard;
